const drag = {
  // Vue 3 中使用 mounted 钩子
  mounted(el, binding) {
    // 1. 解析修饰符和参数
    const isX = binding.modifiers.x || false;
    const isY = binding.modifiers.y || false;
    const isDefault = !binding.modifiers.x && !binding.modifiers.y;
    const fn = binding.value;

    const ifMoveSizeArea = 20;
    let endX, endY;

    el.onmousedown = (e) => {
      // 检查锁定状态
      const isLock = el.getAttribute('data-lock');
      if (isLock === 'true') return;

      // 2. 寻找最近的 absolute 定位父级
      let target = el;
      while (
        window.getComputedStyle(target).position !== 'absolute' &&
        target !== document.body
      ) {
        target = target.parentElement;
      }

      // 禁用文本选中
      document.onselectstart = () => false;

      // 3. 初始化坐标记录
      if (!target.getAttribute('init_x')) {
        target.setAttribute('init_x', target.offsetLeft);
        target.setAttribute('init_y', target.offsetTop);
      }

      const initX = parseInt(target.getAttribute('init_x'));
      const initY = parseInt(target.getAttribute('init_y'));
      const minTop = parseInt(el.getAttribute('drag-min-top')) || 0;

      // 计算初始偏移
      const disX = e.clientX - target.offsetLeft;
      const disY = e.clientY - target.offsetTop;

      // 4. 移动事件
      document.onmousemove = (e) => {
        const l = e.clientX - disX;
        const t = e.clientY - disY;
        
        endX = l;
        endY = t < minTop ? minTop : t;

        // 应用位移
        if (isX || isDefault) {
          target.style.left = endX + 'px';
        }
        if (isY || isDefault) {
          target.style.top = endY + 'px';
        }

        // 执行回调
        if (typeof fn === 'function') {
          fn({ left: endX, top: endY, el });
        }

        // 判断是否触发了有效拖拽
        if (Math.abs(l - initX) > ifMoveSizeArea || Math.abs(t - initY) > ifMoveSizeArea) {
          target.setAttribute('dragged', '');
        } else {
          target.removeAttribute('dragged');
        }
      };

      // 5. 停止拖拽
      document.onmouseup = () => {
        if (typeof fn === 'function') {
          fn({ left: endX, top: endY, el, isEnd: true });
        }
        document.onmousemove = null;
        document.onmouseup = null;
        document.onselectstart = null;
      };

      return false;
    };
  },
  
  // 建议增加 unmounted 钩子进行清理
  unmounted(el) {
    el.onmousedown = null;
  }
};

export default drag;